import { Box, HStack } from "@chakra-ui/react";
import React from "react";
import LeftSidebar from "../../components/LeftSideBarLayout/LeftSideBar";
import HeaderBar from "../../components/Header/HeaderBar";
import ProductCatalogueItemsInfo from "../../components/ProductCatalogueItems/ProductCatalogueItemsInfo";
import Footer from "../../components/footer";

const ProductCatalogue = () => {
    return (
        <>
            <Box backgroundColor='#F0F4F9' height={"100%"}>
                <HStack pl='20px' pr={"6px"} w={"100%"} spacing={0} alignItems='flex-start'>
                    <LeftSidebar />
                    <Box as='main' minW={0} flex={1} ml={"6px"}>
                        <HeaderBar />
                        <ProductCatalogueItemsInfo />
                        <Footer />
                    </Box>

                </HStack>
            </Box>
        </>
    )
}

export default ProductCatalogue